<template>
  <router-view/>
</template>

<script>
  export default {
    created() {
      const stage = process.env.STAGE
      if(stage !== 'prod') {
        document.title = `[${stage}] ${document.title}`
      }
    }
  }
</script>


// WEBPACK FOOTER //
// client/components/App.vue